<template lang="pug">
  span
    button.action-button
      slot
</template>

<script>
export default {
  props: {
    isLoading: {
      default: false,
      type: Boolean,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
